import { buildHeaders, generateNonce } from "@bkry/bowline-utils";
import { ethers } from "ethers";
const { REACT_APP_GEN3RATOR_HOST, REACT_APP_GENERATOR_CLAIM_PHASE } =
  typeof window !== "undefined" && window.env ? window.env : process.env; // TODO not a good idea

export const preparePrizeFormSubmit = async ({
  account,
  provider,
  connector,
  tokenId,
  contractAddress,
  chainId,
  firstName,
  lastName,
  streetAddress,
  zipCode,
  city,
  country,
  imxPassportAddress,
  formWalletAddress,
  prize,
  errorCallbackFnc,
  transactionCallbackFnc,
}) => {
  try {
    const nonce = generateNonce(8);
    const nonceIssuedAt = new Date().toUTCString();

    const ethersProvider =
      provider ||
      (connector?.provider &&
        new ethers.providers.Web3Provider(connector?.provider, "any")) ||
      (window.ethereum &&
        new ethers.providers.Web3Provider(window.ethereum, "any"));
    const signer = ethersProvider.getSigner();

    const { hostname, origin } = window.location;
    const message = `${hostname} wants you to claim the prize "${prize}" for GEN3RATOR #${tokenId} with the wallet ${account}.
Contact information:
${firstName ? `- Fist name ${firstName}` : ""}${
      lastName ? `\n- Last name ${lastName}` : ""
    }${streetAddress ? `\n- Street Address ${streetAddress}` : ""}${
      zipCode ? `\n- Zip code ${zipCode}` : ""
    }${city ? `\n- City ${city}` : ""}${
      country ? `\n- Country ${country}` : ""
    }${
      imxPassportAddress ? `\n- IMX Passport Address ${imxPassportAddress}` : ""
    }${formWalletAddress ? `\n- Wallet Address ${formWalletAddress}` : ""}

I hereby accept the Terms of Service: https://bowline.app/tos

  URI: ${origin}
  Issued At: ${nonceIssuedAt}
  `;

    const signature = await signer.signMessage(message);

    return await prizeFormSubmit({
      account,
      contractAddress,
      signature,
      nonce,
      nonceIssuedAt,
      chainId,
      tokenId,
      firstName,
      lastName,
      streetAddress,
      zipCode,
      city,
      country,
      imxPassportAddress,
      formWalletAddress,
      prize,
      errorCallbackFnc,
      transactionCallbackFnc,
    });
  } catch (e) {
    console.error(e);
    if (errorCallbackFnc) errorCallbackFnc(e);
  }
};

const prizeFormSubmit = async ({
  account,
  contractAddress,
  signature,
  nonce,
  nonceIssuedAt,
  chainId,
  tokenId,
  firstName,
  lastName,
  streetAddress,
  zipCode,
  city,
  country,
  imxPassportAddress,
  formWalletAddress,
  prize,
  errorCallbackFnc,
  transactionCallbackFnc,
}) => {
  let headers = await buildHeaders();

  try {
    const response = await fetch(
      `${REACT_APP_GEN3RATOR_HOST}/token/${contractAddress}/${tokenId}/claimPrize`,
      {
        method: "POST",
        headers,
        body: JSON.stringify({
          account,
          contractAddress,
          signature,
          nonce,
          nonceIssuedAt,
          chainId,
          tokenId,
          firstName,
          lastName,
          streetAddress,
          zipCode,
          city,
          country,
          imxPassportAddress,
          formWalletAddress,
          prize,
          claimPhase: REACT_APP_GENERATOR_CLAIM_PHASE,
        }),
      }
    );
    const data = await response.json();

    if (!response.ok) throw new Error(data.message);

    if (transactionCallbackFnc) transactionCallbackFnc();

    return data;
  } catch (e) {
    console.error(e);
    if (errorCallbackFnc) errorCallbackFnc(e);
  }
};

export const getPrize = async ({ chainId, contractAddress, tokenId }) => {
  let headers = await buildHeaders();

  try {
    const response = await fetch(
      `${REACT_APP_GEN3RATOR_HOST}/chain/${chainId}/token/${contractAddress}/${tokenId}/prize?claimPhase=${REACT_APP_GENERATOR_CLAIM_PHASE}`,
      { headers }
    );
    const data = await response.json();

    return data;
  } catch (e) {
    console.error(e);
  }
};

export const getFormNotFilledStatus = async ({ contractAddress, tokenId }) => {
  let headers = await buildHeaders();

  try {
    const response = await fetch(
      `${REACT_APP_GEN3RATOR_HOST}/token/${contractAddress}/${tokenId}/not_filled`,
      { headers }
    );
    const data = await response.json();

    return data;
  } catch (e) {
    console.error(e);
  }
};

export const prepareWalletTokenClaim = async ({
  generatorContractAddress,
  generatorTokenId,
  generatorContractName,
  generatorContractChainId,
  claimPhase,
  provider,
  connector,
  minter,
  successCallbackFnc,
  errorCallbackFnc,
  transactionCallbackFnc,
}) => {
  try {
    const ethersProvider =
      provider ||
      (connector?.provider &&
        new ethers.providers.Web3Provider(connector?.provider, "any")) ||
      (window.ethereum &&
        new ethers.providers.Web3Provider(window.ethereum, "any"));

    const signer = ethersProvider.getSigner();

    const domain = {
      name: generatorContractName,
      version: "1",
      chainId: generatorContractChainId,
      verifyingContract: ethers.utils.getAddress(generatorContractAddress),
    };

    const types = {
      Gen3ratorClaim: [
        { name: "wallet", type: "address" },
        { name: "tokenId", type: "uint256" },
        { name: "claimPhase", type: "uint256" },
      ],
    };

    const message = {
      wallet: ethers.utils.getAddress(minter),
      tokenId: generatorTokenId,
      claimPhase,
    };

    const signature = await signer._signTypedData(domain, types, message);

    return await claimToken({
      generatorContractAddress,
      generatorTokenId,
      generatorContractChainId,
      claimPhase,
      minter,
      signature,
      successCallbackFnc,
      errorCallbackFnc,
      transactionCallbackFnc,
      ethersProvider,
    });
  } catch (e) {
    if (errorCallbackFnc) errorCallbackFnc(e);
    console.error(e);
  }
};

const claimToken = async ({
  generatorContractAddress,
  generatorTokenId,
  generatorContractChainId,
  claimPhase,
  minter,
  signature,
  successCallbackFnc,
  errorCallbackFnc,
  transactionCallbackFnc,
  ethersProvider,
}) => {
  let headers = await buildHeaders();

  try {
    if (successCallbackFnc) successCallbackFnc();

    const response = await fetch(
      `${REACT_APP_GEN3RATOR_HOST}/token/${generatorContractAddress}/${generatorTokenId}/claim`,
      {
        method: "POST",
        headers,
        body: JSON.stringify({
          generatorContractChainId,
          claimPhase,
          minter,
          signature,
        }),
      }
    );

    const transaction = await response.json();

    if (transaction?.hash) {
      ethersProvider.once(transaction?.hash, () => {
        if (transactionCallbackFnc) transactionCallbackFnc();
      });
    }

    if (!response.ok && errorCallbackFnc) errorCallbackFnc(transaction);

    return transaction;
  } catch (e) {
    if (errorCallbackFnc) errorCallbackFnc(e);
    console.error(e);
  }
};
